module.exports = __webpack_public_path__ + "static/Fabriga-a4cbcb7b79751fd954bc387f74fea98a.woff2";